import { makeAction } from "async-action-creator";
import { notification } from "antd";

import i18n from "../../i18n";
import api from "../../utils/api";
import { createApiThunk } from "../../utils/thunk";

export const FETCH_NEW_MESSAGES = makeAction("chat/FETCH_NEW_MESSAGES");
export const CLIENT_CONNECT = makeAction("chat/CLIENT_CONNECT");
export const CLIENT_CLOSE = makeAction("chat/CLIENT_CLOSE");
export const NEW_MESSAGE = makeAction("chat/NEW_MESSAGE");
export const MESSAGES_READ = makeAction("chat/MESSAGES_READ");
export const SEND_MESSAGE = makeAction("chat/SEND_MESSAGE");
export const DELETE_MESSAGE = makeAction("chat/DELETE_MESSAGE");
export const UNSET = makeAction("chat/UNSET");
export const SEND_FILE = makeAction("chat/SEND_FILE");

export const sendMessage = (
  msg,
  { company, candidate, opportunity }
) => async dispatch => {
  try {
    dispatch(
      SEND_MESSAGE.start({
        company,
        candidate,
        msg,
        opportunity
      })
    );

    const messages = await api.messages.sendMessage(
      msg,
      company,
      candidate,
      opportunity
    );

    dispatch(SEND_MESSAGE.resolve({ messages, candidate }));
  } catch (error) {
    dispatch(SEND_MESSAGE.reject({ msg, company, candidate, opportunity }));

    notification.error({
      message: i18n.t("global:error"),
      description: i18n.t("toasts:chatError")
    });
  }
};

export const messageRead = createApiThunk({
  action: MESSAGES_READ,
  request: async ({ idOpportunity, idCandidate, idCompany }) => {
    await api.messages.read(idOpportunity, idCandidate, idCompany);
    return { idOpportunity, idCandidate, idCompany };
  }
});

const MAX_LENGTH = 5000000; // 5Mbs;

export const sendFile = createApiThunk({
  action: SEND_FILE,
  rejectOnError: true,
  request: async ({ file, company, opportunity, candidate }) => {
    if (file.size > MAX_LENGTH) {
      notification.error({
        message: i18n.t("global:error"),
        description: i18n.t("toasts:fileLimit", {
          size: MAX_LENGTH / 1000000
        })
      });
      return null;
    }
    const { location } = await api.messages.sendFile(
      company,
      opportunity,
      candidate,
      file
    );
    return location;
  },
  onRejected: () =>
    notification.error({
      message: i18n.t("global:error"),
      description: i18n.t("toasts:chatError")
    })
});
